import React from 'react';
import Card from '../../../components/ui/Card';
import Icon from '../../../components/AppIcon';

const NotificationStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Notifications',
      value: stats?.total || 0,
      icon: 'Bell',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      label: 'Unread',
      value: stats?.unread || 0,
      icon: 'BellDot',
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600'
    },
    {
      label: 'Critical Priority',
      value: stats?.critical || 0,
      icon: 'AlertTriangle',
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600'
    },
    {
      label: 'High Priority',
      value: stats?.high || 0,
      icon: 'AlertCircle',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <Card key={index} className="p-4">
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat?.icon} className={`w-6 h-6 ${stat?.iconColor}`} />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{stat?.value}</p>
              <p className="text-sm text-gray-600">{stat?.label}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default NotificationStats;